import { Injectable } from '@angular/core';
import { Veiculo } from '@tivic-team/manager-ts/dist/fta/entities/veiculo.entity';
import { VeiculoController } from 'app/controllers/fta/veiculo.controller';
import { LoaderService } from '../loader.service';


@Injectable()
export class VeiculoService {

  constructor(
    private _veiculoController: VeiculoController,
    private _loaderService: LoaderService
  ) {}

  async consultarDetran(nrPlaca:string):Promise<JSON>{
    this._loaderService.show();
    return this._veiculoController.consultarDetran(nrPlaca).finally(() => this._loaderService.hide());
  }

  async save(veiculo: Veiculo): Promise<Veiculo> {
    console.log('Loading Veiculo Service...');
    this._loaderService.show();
    if (veiculo.cdVeiculo && veiculo.cdVeiculo > 0) {
        console.log('Update');
        return this._veiculoController.update(veiculo).finally(() => this._loaderService.hide());
    } else {
        console.log('Create');
        return this._veiculoController.create(veiculo).finally(() => this._loaderService.hide());
    }
  }
}
